<span class="header-name">
    <span
        class="header-title"
        (click)="sort()"
    >
        {{ params.name | wrapHeaderText }}
        <i
            *ngIf="params.enableSorting"
            [class]="sortIcon"
        ></i>
    </span>
    <i
        class="fas fa-filter padding-right-75-em"
        *ngIf="isFilterActive()"
        #filterIcon
        (click)="openFilterMenu($event, filterIcon)"
    >
    </i>
    <i [class]="params.icon"></i>
</span>

<div
    #floatingFilterContainer
    class="floating-filter-container"
></div>
